// Single source of truth for algorithm → color, shared by the summary/algorithm chips and the
// masked-field grid labels (spec §3). Categorical set built from the C2 style-guide brand +
// semantic hues (blue #315DFF, violet #7360F6, cyan #00C4F0, violet-300 #B78AF8, green #16A34A,
// amber #D97706, plus INK 300/500 for overflow). Unknown algorithms fall back to neutral ink.

const NEUTRAL = { bg: '#EEF1F5', text: '#475569', border: '#E5E8ED', solid: '#5C6473' };

const ALG = {
  HASH: { bg: '#EEF1F5', text: '#475569', border: '#E5E8ED', solid: '#5C6473' }, // ink 500
  REDACT: { bg: '#EFEBFE', text: '#5B48D6', border: '#DDD5FC', solid: '#7360F6' }, // brand violet
  DATE_SHIFT: { bg: '#E9EEFF', text: '#1E40AF', border: '#C7D4FB', solid: '#315DFF' }, // brand blue
  MASK_EMAIL: { bg: '#E6FAFE', text: '#0891B2', border: '#B3ECFA', solid: '#00C4F0' }, // brand cyan
  FAKE_NAME: { bg: '#F4EDFE', text: '#8A55E0', border: '#E4D3FC', solid: '#B78AF8' }, // violet 300
  NULLIFY: { bg: '#EDEFF2', text: '#5C6473', border: '#D9DDE3', solid: '#8A92A0' }, // ink 300/400
  // NOT red: red duplicates the failure style (FAIL below) and made every healthy
  // CREDIT_CARD chip read as an error. Red is reserved for failed === true.
  CREDIT_CARD: { bg: '#EEF1F5', text: '#475569', border: '#E5E8ED', solid: '#5C6473' }, // neutral ink, like other entity types
  TOKENIZE: { bg: '#FEF3C7', text: '#B45309', border: '#F3DFA8', solid: '#D97706' }, // amber
};

export const FAIL_RED = '#DC2626';
const FAIL = { bg: '#FEE2E2', text: '#B91C1C', border: '#F6C9C9' };

const tokens = (algorithm) => ALG[algorithm] || NEUTRAL;

/** Solid color for the field-grid algorithm label text. */
export function algColor(algorithm) {
  return tokens(algorithm).solid;
}

/** Inline style for an algorithm chip; turns red when `failed` (its algorithm appears in errors[]). */
export function algChipStyle(algorithm, failed) {
  const t = failed ? FAIL : tokens(algorithm);
  return {
    backgroundColor: t.bg,
    color: t.text,
    border: `1px solid ${t.border}`,
  };
}
